export default __webpack_public_path__ + "static/media/Knockout-HTF46-Flyweight.5bd7c7a0.otf";